<section class="mt-2">
    <div class="action-btn px-4">
        <button class="mr-5" nz-button nzType="default" (click)="resetForm()">Reset</button>
        <button nz-button nzType="primary" (click)="saveRow()">Save</button>
    </div>
    <div class="form-container position-relative mt-3">
        <span style="top:20px" *ngIf="invalidForm" class="error-text">
            Atleast one EDP/AR # and/or Lot Id value is required
        </span>
        <div class="mt-1 mb-3 d-flex justify-content-end px-1">
            <button nz-button nzType="primary" (click)="addRow()">Add New</button>
        </div>
        <div class="row">
            <nz-collapse cdkDrag class="mb-3" style="background-color: #ffff;" nzAccordion>
                <nz-collapse-panel style="padding-bottom: 20px;" [nzDisabled]="true" #panelRef [nzActive]="true"
                    [nzShowArrow]="false">
                    <div class="row d-flex align-self-center align-items-center mb-2">
                        @for(list of priceDisplayList;let j = $index; track list.id){
                        @if(list.fieldType == 'select'){
                        <ng-container>
                            <div class="mb-4 d-flex flex-column position-relative col-md-4">
                                <label class="form-label"> {{list.fieldName}}
                                    @if(list.fieldName == 'EDP/AR #'){ <span class="text-danger">*</span> }
                                </label>
                                @if(list.placeholder == 'Select EDP/AR #'){

                                <nz-select (keydown)="onlyNumberKey($event)" [(ngModel)]="list.value"
                                    (ngModelChange)="onEdpUpdate($event, j)" (nzOnSearch)="getEdpArNoList($event)"
                                    nzPlaceHolder={{list?.placeholder}} nzSize="default" [nzShowSearch]="true"
                                    style="height: 35px !important;;" #ARSelect
                                    [nzStatus]="list.edpMissing ? 'error' : ''">
                                    @for(edpAr of edpArList;track edpAr ){
                                    <nz-option [nzLabel]="edpAr" [nzValue]="edpAr"></nz-option>
                                    }
                                </nz-select>
                                @if (list.edpMissing) {
                                <span class="error-text" style="margin-bottom: 25px">
                                    EDP/AR # is required when a Lot is selected.
                                </span>
                                }
                                }
                                @else {<nz-select nzAllowClear [nzMode]="'multiple'"
                                    (keydown.tab)="handleTabOut($any($event), list)"
                                    (keydown)="onlyAlphanumeric($event)" class="input-block" #multiSelectRef="nzSelect"
                                    nzPlaceHolder="{{list?.placeholder}}" nzSize="default" [nzServerSearch]="true"
                                    style="height: 35px !important;margin-bottom: 25px;" [(ngModel)]="list.value"
                                    [nzDropdownRender]="dropDownRender" (ngModelChange)="onLotUpdate($event, j)"
                                    (nzOnSearch)="getLotList($event, j)" (nzOpenChange)="handleOpenChange($event, j)">

                                    @for(lot of list?.lotList; track lot.lotNo) {
                                    <nz-option [nzDisabled]="lot.disabled" [nzLabel]="lot.lotNo"
                                        [nzValue]="lot.lotNo"></nz-option>
                                    }
                                </nz-select>
                                <ng-template #dropDownRender>
                                    <div class="d-flex justify-content-end p-2">
                                        <button nz-button nzType="primary" class="ok-btn"
                                            (click)="closeSelect(multiSelectRef,$event,j)">
                                            Ok
                                        </button>
                                    </div>
                                </ng-template>}
                            </div>
                        </ng-container>
                        }
                        @else if(list.fieldType == 'toggle'){
                        <div class="col-md-3 d-flex align-items-center flex-column">
                            @if(list.fieldName){
                            <label style="height: 35px;" class="form-label">
                                {{list.fieldName}}
                            </label>
                            }
                            <nz-switch style="margin-bottom: 35px;" [(ngModel)]="list.value"></nz-switch>
                        </div>
                        }
                        @else if(list.fieldType == 'button' ) {
                        <div class="col-md-1 d-flex justify-content-center mt-4">
                            <button (click)="clearRow(list)" style="height: 32px;margin-bottom: 30px;"
                                class="margin-right" nz-button nzType="default">Clear</button>
                        </div>
                        }
                        }
                    </div>
                </nz-collapse-panel>
            </nz-collapse>
        </div>
    </div>
</section>